'use client'

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { ArrowUpDown, Divide, SlidersHorizontal } from 'lucide-react'
import { SortBy } from '@/components/products/SortBy'
import { FilterModal } from '@/components/products/FilterModal'
import { useSearchParams } from 'next/navigation'
import useCommonStore from '@/store/commonStore'

export function FilterAndSorting() {
  const [sortOpen, setSortOpen] = useState(false)
  const [filterOpen, setFilterOpen] = useState(false)
  const [loading, setLaoding] = useState(false)
  const [selectedFilterCount, setSelectedFilterCount] = useState(0)
  const [selectedSortCount, setSelectedSortCount] = useState(0)
  const { fetchCategoryFilters, translations } = useCommonStore()
  const loadFilter = async () => {
    setLaoding(true)
    await fetchCategoryFilters()
    setLaoding(false)
  }
  useEffect(() => {
    loadFilter()
  }, [])
  const searchParams = useSearchParams()
  useEffect(() => {
    let f_count = 0
    let s_count = 0
    searchParams?.forEach((_value, key) => {
      if (key.startsWith("f_")) f_count += 1
    })
    searchParams?.forEach((_value, key) => {
      if (key.startsWith("s_")) s_count += 1
    })
    setSelectedFilterCount(f_count)
    setSelectedSortCount(s_count)
  }, [searchParams])

  return (
    <>
        {
          loading ? (null) : (
            <div className="flex gap-2 w-full bg-white shadow-lg px-4 py-2">
              <button
                className="flex-1 flex items-center justify-center gap-2 py-1 text-sm "
                onClick={() => setFilterOpen(true)}
              >
                <SlidersHorizontal className="w-4 h-4" />
                <p className='relative'>
                  {translations["filter"] || "Filter"}
                  {selectedFilterCount > 0 && <span className='absolute -top-1 -right-4 bg-red-500 text-white font-semibold text-xs rounded-full px-1 rtl:-left-4 rtl:right-auto'>{selectedFilterCount}</span>}
                </p>
              </button>
              <div className="divide-x divide-gray-300 w-px bg-gray-200" />
                <button
                  className="flex-1 flex items-center justify-center gap-2 py-1 text-sm"
                  onClick={() => setSortOpen(prev => !prev)}
                >
                  <ArrowUpDown className="w-4 h-4" />
                  <p className="relative">
                    {translations["sort"] || "Sort"}
                    {selectedSortCount > 0 && <span className='absolute -top-1 -right-4 bg-red-500 text-white font-semibold text-xs rounded-full px-1 rtl:-left-4 rtl:right-auto'>{selectedSortCount}</span>}
                  </p>
                </button>
            </div>
          )
        }

      <SortBy
        open={sortOpen}
        onClose={() => setSortOpen(false)}
      />

      {filterOpen && createPortal(
        <FilterModal
          open={filterOpen}
          onClose={() => setFilterOpen(false)}
        />,
        document.body
      )}
    </>
  )
}